exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.enroll_tabs[data-v-c51ab5ce] {\n  padding: 12px;\n}\n", ""]);

// exports
